<template>
  <v-dialog content-class="share-link-test" v-model="dialog" max-width="500px">
    <v-card min-width="21vw" align="center" justify="center" outlined class="custom-border">
      <v-card-title>
            <h2 class="share-title">{{ $t('title_ShareLinkTest') }}</h2>
          <v-spacer />
          <v-list-item-action><v-icon class="icon close-icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
        <p class="share-with-network ">{{ tournamentParticipant ?  $t('description_tournament') :  $t('description_ShareLinkTest') }}</p>
      </v-card-title>
      <v-card-text >
        <label for="textToCopy">{{ $t("label_ShareLinkTest") }}</label>
        <v-text-field class="textToCopy" v-model="link" id="textToCopy" readonly @click="copyText" outlined />
        <v-icon @click="copyText">fa-regular fa-copy</v-icon>
      </v-card-text>
    </v-card>
    <v-snackbar color="var(--v-mainGreen-base)" v-model="showMsg">
            {{  $t("successCopy") }}
        </v-snackbar>
  </v-dialog>
</template>

<script>
export default {
  name: "ShareLink",
  props: {
    fundingChallengeTestId: {
      type: String,
      required: true
    },
    tournamentParticipant: {
      type: Object,
      required: false,
      default: undefined
    },
  },
  data() {
    return {
      link: '',
      dialog: true, // Controla la visibilidad del modal
      showMsg: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if(this.tournamentParticipant) {
        this.link = `https://app.swiset.com/tournaments/embed-rank?tournamentId=${this.$store.state.tournament.tournamentId}&identifier=${this.tournamentParticipant.brokerAccountIdentifier}`;
      } else {
        this.link = `https://app.swiset.com/funding-simulation/summary?id=${this.$store.state.fundingTest.id}&identifier=${this.$store.state.fundingTest.account.identifier}`;
      }
      
    },
    copyText() {
      let textToCopy = document.getElementById("textToCopy");
      textToCopy.select();
      document.execCommand("copy");
      this.showMsg = true;
    },
    closeWindow() {
      this.dialog = false;
      this.$emit('closeWindow');
    }
  },
}
</script>


<style lang="scss">
.theme--dark {
  .share-link-test {
  &.v-dialog {
    .v-card {
      .v-card__text {
          .textToCopy{
          .v-input__slot{
            fieldset{
              background: #4E5966;
            }
          }
        }
      }
    }
  }
}
}
.share-link-test {
  &.v-dialog {
    border-radius: 15px;
    .v-card {
      .v-card__text {
        position: relative;
        padding-bottom: 0;
          .textToCopy{
          .v-input__slot{
            padding-right: 64px;
            border-radius: 10px;
            fieldset{
              background: #EEEEEE;
              border: none;
            }
          }
          #textToCopy{
            padding-right: 28px !important;
          }
        }
        label{
          text-align: start;
          display: flex;
          font-size: 14px;
          color: var(--v-mainBlack-base);
          font-family: 'Avenir', sans-serif;
        }
        .v-icon {
          position: absolute;
          top: 28px;
          font-size: 16px;
          border: none;
          right: 25px;
          background-color: transparent !important;
          &:hover{
            cursor: pointer;
          }
        }
      }
      .share-title{
        font-size: 32px;
        font-weight: bold;
        color: var(--v-mainGreen-base);
        margin-top: 42px;
        text-align: start;
        padding: 0;
      }
      .share-with-network{
        font-size: 16px;
        margin-bottom: 40px;
        text-align: start;
      }
      .close-icon{
        color: var(--v-mainBlack-base) !important;
        font-size: 18px;
        margin-bottom: 42px;
      }
    }
  }
}
</style>
